import { render, staticRenderFns } from "./AMotivo-create.vue?vue&type=template&id=f2238386"
import script from "./AMotivo-create.vue?vue&type=script&lang=js"
export * from "./AMotivo-create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports